import {
  Dialog,
  DialogButton,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogIllustration,
  DialogTitle,
} from 'components/Dialog'
import { FormGroup } from 'components/inputs'
import { MultiStringSelect } from 'iam/pro-details/StringSelect'
import { SOFTWARE_VALUES } from 'iam/wellKnownProviderValues'
import { observer } from 'mobx-react'
import React from 'react'
import ProSoftwareReviewModalViewModel from './ProSoftwareReviewModalViewModel'

interface Props {
  vm: ProSoftwareReviewModalViewModel
}

export default observer(function ProSoftwareReviewModal({ vm }: Props) {
  const details = vm.details
  return (
    <Dialog
      showing={vm.showing}
      onClose={false}
      disableCloseOnOutsideClick
      disableCloseOnEsc
    >
      <DialogHeader>
        <DialogIllustration
          src={require('assets/images/img_confirmation.svg')}
          alt="Review your software stack"
        />
        <DialogTitle>Review your software stack</DialogTitle>
        <DialogDescription>
          Is your software the same? If it has changed, update to discover new
          business opportunities and unlock growth potential
        </DialogDescription>
      </DialogHeader>
      <DialogContent>
        {details && (
          <FormGroup label="Software Owned">
            <MultiStringSelect
              value={details.softwareOwned}
              options={SOFTWARE_VALUES}
              onChange={details.setSoftwareOwned}
              placeholder="Select software"
              dataTest="pro-software-review-software-owned"
            />
          </FormGroup>
        )}
      </DialogContent>
      <DialogFooter bordered>
        <DialogButton
          type="primary"
          onClick={vm.confirm}
          loading={vm.confirm.pending}
          data-test="pro-software-review-confirm"
        >
          Confirm
        </DialogButton>
      </DialogFooter>
    </Dialog>
  )
})
